import comp from "./LearningIntentions";
export default comp;
